module.exports = __webpack_public_path__ + "static/img/activity_sdy_06-1.ebaa306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_06-1.jpg
// module id = SnWv
// module chunks = 0